import React from 'react';
import { BookOpenIcon, BoneIcon, FlameIcon, LayoutGridIcon, MapPinIcon, PrinterIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { printPackItems } from '../../data/salesContent';
import { PRINT_PACK_IMAGE } from '../../data/product';
const itemIcons = [BookOpenIcon, FlameIcon, MapPinIcon, LayoutGridIcon, BoneIcon];
export function PrintPackSection() {
  return <section className="bg-night py-8 sm:py-12" aria-labelledby="print-title" data-id="element-137" data-mp="2q1ykjjsryy0m">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-138" data-mp="2l2uc4vdod4bc">
        <div id="print-title" data-id="element-139" data-mp="2l340yfmzh5fg">
          <SectionHeading eyebrow="Included with your access" title={<>
                Print It. Cut It. <span className="text-pumpkin" data-id="element-141" data-mp="2bdkjneex5jmp">Use It.</span>
              </>} subtitle="You also receive a separate printable resource pack designed for practical classroom use." data-id="element-140" data-mp="2gbvtvq94lw5g" />
        </div>

        <div className="mt-5 grid gap-5 lg:grid-cols-[1.2fr_1fr] lg:items-center lg:gap-10" data-id="element-142" data-mp="33zvl0racnokk">
          <figure data-id="element-143" data-mp="3vqcd950lq8kk">
            <img src={PRINT_PACK_IMAGE} alt="Halloween Print & Play Pack: teacher quick guide, warm-up routine, four corner signs, movement cards and a Build-a-Skeleton sheet" width={1200} height={896} className="h-auto w-full rounded-3xl border border-line" loading="lazy" decoding="async" data-id="element-144" data-mp="3vr5l69bar44a" />
            <figcaption className="mt-3 flex items-start gap-3 rounded-2xl bg-lime/10 p-3 text-[14px] leading-snug text-cream" data-id="element-145" data-mp="3c36aszkn9yze">
              <PrinterIcon className="mt-0.5 h-5 w-5 shrink-0 text-lime" aria-hidden="true" data-id="element-146" data-mp="330n9ijwibuf9" />
              Designed separately for printing so teachers do not need to print the dark digital guide.
            </figcaption>
          </figure>

          <ul className="space-y-3.5" data-id="element-147" data-mp="11abs4ysqs1ht">
            {printPackItems.map((item, i) => {
            const Icon = itemIcons[i];
            return <li key={item.title} className="flex gap-3" data-id="element-148" data-mp="13t6t38vqio8b" data-mpi={i}>
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-panel text-pumpkin" data-id="element-149" data-mp="13urp72xp6f8a">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-150" data-mp="zu7qhuxh73k1" />
                  </span>
                  <div data-id="element-151" data-mp="uuuw8p49yu7f">
                    <h3 className="font-display text-sm font-extrabold uppercase tracking-wide text-cream" data-id="element-152" data-mp="ptxe2cj9m05x">{item.title}</h3>
                    <p className="mt-0.5 text-[13px] leading-snug text-muted sm:text-sm" data-id="element-153" data-mp="1nhperghj7ji9">{item.text}</p>
                  </div>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}